module.exports = __webpack_public_path__ + "img/magnifying.86dc45fe.jpg";